import { notificationInitialState } from "./initial-state.js";
import { reducers_exports } from "./reducers.js";
import { createSlice } from "@reduxjs/toolkit";
var slice = createSlice({
	name: "notification",
	initialState: notificationInitialState,
	reducers: reducers_exports
});
var actions = slice.actions;
var reducer = slice.reducer;
//#endregion
export { actions, reducer, slice };

//# sourceMappingURL=slice.js.map